export const setConfig = (config) => ({
  type: "CONFIG/SET_CONFIG",
  payload: config,
});
